import React, { useContext } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import { SupabaseUserContext } from "../contexts/supabaseUser.context";
import { useTheme } from "../contexts/ThemeContext";
import { getMm } from "../theme/modernMaterialEnterprise";

/**
 * Full-page block when Control Center has suspended the academy platform subscription.
 */
export default function PlatformSuspendedScreen({ clubID }) {
  const { logOutUser } = useContext(SupabaseUserContext);
  const { isDarkMode } = useTheme();

  const onSignOut = async () => {
    await logOutUser();
    window.location.href = "/login?reason=platform_suspended";
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        px: 2,
        backgroundColor: getMm(isDarkMode).surfaceLow,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
    >
      <Paper
        sx={{
          maxWidth: 480,
          width: "100%",
          p: 4,
          border: "2px solid",
          borderColor: getMm(isDarkMode).outlineVariant,
          boxShadow: "none",
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Box
          component="img"
          src={isDarkMode ? "NewEraLogo.png" : "NewEraBlackLogo.png"}
          alt="NewEra"
          sx={{ height: 48, mb: 2 }}
        />
        <Typography variant="h5" fontWeight={800} sx={{ mb: 1 }}>
          Academy access suspended
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          This academy&apos;s NewEra subscription is inactive
          {clubID != null ? ` (Club ID ${clubID})` : ""}. Contact your head coach or NewEra
          support.
        </Typography>
        <Button variant="contained" color="primary" onClick={onSignOut}>
          Sign out
        </Button>
      </Paper>
    </Box>
  );
}
